import { render, staticRenderFns } from "./TransactionTypeCard.vue?vue&type=template&id=29b6fa10&"
import script from "./TransactionTypeCard.vue?vue&type=script&lang=js&"
export * from "./TransactionTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports